import { useQuery } from '@tanstack/react-query';

import { Timeline, type TimelineItem } from '@/components/composed/Timeline';
import { Skeleton } from '@/components/ui/skeleton';
import { invoiceEventsQuery } from '../api/invoice-queries';
import type { InvoiceId } from '@/lib/api/ids';

/** Maps invoice events into the domain-free Timeline (spec §7.3, §7.6). */
export function InvoiceTimeline({ invoiceId }: { invoiceId: InvoiceId }) {
  const query = useQuery(invoiceEventsQuery(invoiceId));

  if (query.isLoading) {
    return <Skeleton className="h-24 w-full" />;
  }
  if (query.isError || !query.data) {
    return <p className="text-sm text-destructive">Failed to load activity.</p>;
  }

  const items: TimelineItem[] = query.data.items.map((e) => ({
    id: e.id,
    title: e.summary,
    at: e.at,
    ...(e.actor ? { detail: `by ${e.actor}` } : {}),
  }));

  return <Timeline items={items} />;
}
